import { ReactElement } from 'react'
import { Home } from '../presentation/components/home/home'
import './app.css'
import { makeApiLoadFranchise } from './helper/factories/api-load-franchise'

const apiUrl = String(process.env.REACT_APP_BASEURL)
const loadFranchise = makeApiLoadFranchise()

function App (): ReactElement {
  return <Home loadFranchise={loadFranchise} apiUrl={apiUrl} />
}

export default App
